import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ManageService } from '../../../../services/manage.service';
import { CommonService } from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ConfirmNCESubscriptionComponent } from '../../../../popup-collection/confirm-nce-subscription/confirm-nce-subscription.component';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PanelService } from '../../../../services/panel.service';
import { DatePipe } from '@angular/common';
import { WGSSubscriptionDetail } from '../../../../models/wgs.model';

@Component({
  selector: 'app-manage-watchguard-subscription',
  templateUrl: './manage-watchguard-subscription.component.html',
  styleUrls: ['./manage-watchguard-subscription.component.css'],
  providers: [DatePipe]
})
export class ManageWatchguardSubscriptionComponent implements OnInit, OnDestroy, AfterViewInit {
  public detail: WGSSubscriptionDetail = {} as WGSSubscriptionDetail;

  public showStatusToggleSpinner = true;
  public disableStatusButton = false;
  public showSerialSpinner = true;

  private tenantId: string;
  private subscriptionId: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public wgsSubscriptionForm = this.fb.group({
    serial: [{ value: '', disabled: true }],
    status: [{ value: false, disabled: true }]
  });

  public get statusToggleButton(): AbstractControl {
    return this.wgsSubscriptionForm.get('status')
  }

  public get serialInput(): AbstractControl {
    return this.wgsSubscriptionForm.get('serial')
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    if (!$('#confirmWGSProduct').length && !$('#addWGSProduct').length) {
      $('#levelOne').animate({ scrollLeft: $('#managewgs').width() + 505 }, 400);
    }
  }

  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    public commonService: CommonService,
    private router: Router,
    private fb: FormBuilder,
    public sidenavService: PanelService
  ) { }

  ngOnInit() {
    combineLatest([
      this.manageService.getCurrentWGSContractResellerId,
      this.activatedRoute.params,
      this.manageService.currentWGSSubscriptionDetail
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([resellerId, subParams, res]) => {

        this.tenantId = resellerId;
        this.subscriptionId = subParams['subId'];
        if (res) {
          this.detail = res;
          this.statusToggleButton.setValue(!this.detail?.subscriptionStatus.toLowerCase().includes('suspend'));
          this.serialInput.setValue(this.detail?.serialNumber);
          this.statusToggleButton.enable();
          this.serialInput.enable();
          this.showStatusToggleSpinner = false;
          this.showSerialSpinner = false;
        } else {
          this.getWGSSubscriptionDetail();
        }
      });
          
    //this is used for the scrolling the content
    setTimeout(() => {
      this.activatedRoute.paramMap.subscribe(param => {
        if (!$('#managecsp').length) {
          $('#levelOne').animate({ scrollLeft: 1234 }, 400);
        }
      }
      );
    }, 300);
  }

  private getWGSSubscriptionDetail() {
    if (this.tenantId && this.subscriptionId) {
      this.manageService.GetWGSSubscriptionDetail(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toUpperCase())
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail: WGSSubscriptionDetail) => {
        if (!this.commonService.isEmpty(detail)) {

          this.detail = detail
          this.manageService.updateWGSdetailView$.next(detail)
          this.statusToggleButton.setValue(!this.detail?.subscriptionStatus.toLowerCase().includes('suspend'));
          this.disableStatusButton = !this.detail?.subscriptionStatus.toLowerCase().includes('active');
          this.serialInput.setValue(this.detail?.serialNumber);
          this.statusToggleButton.enable();
          this.serialInput.enable();
          this.showStatusToggleSpinner = false;
          this.showSerialSpinner = false;
        }
      }, (error: any) => {
        this.commonService.implementToast(error, 'Error');
      })
    }
  } 

  public toggleStatusHandler(): void {
    // prepare texts for popup display
    const status = this.statusToggleButton.value ? 'active' : 'suspend';
    const title = this.statusToggleButton.value ? "Confirm Activate" : "Confirm Suspension";
    const text = `This will ${this.statusToggleButton.value ? 'activate' : 'suspend'} service, you will continue to accrue charges as per this subscriptions existing commitment.`;

    // show confirm popup
    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.statusToggleButton.disable();
          this.showStatusToggleSpinner = true;
          this.manageService.toggleWGSStaus(status, this.subscriptionId, this.tenantId).subscribe((res: any) => {
            if (res?.isSuccess) {
              this.commonService.implementToast("Updated successfully", "Success");
              this.getWGSSubscriptionDetail();
            } else {
              this.commonService.implementToast(res?.errorMessage, 'Error');
              this.statusToggleButton.setValue(!this.statusToggleButton.value);
            }
            this.statusToggleButton.enable();
            this.showStatusToggleSpinner = false;
          });
        } else {
          // if user cancel the popup window we need to set the toggle back
          this.statusToggleButton.setValue(!this.statusToggleButton.value)
        }
      })
  }

  public cancelSubscription(): void {
    const title = "Confirm Cancel";
    const text = `This will cancel the service at the end of the current term.`;

    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.statusToggleButton.disable();
          this.showStatusToggleSpinner = true;
          this.disableStatusButton = true;
          this.manageService.cancelWGSContract(this.subscriptionId, this.tenantId).subscribe((res: any) => {
            if (res?.isSuccess) {
              this.commonService.implementToast("Updated successfully", "Success");
              this.getWGSSubscriptionDetail();
            } else {
              this.commonService.implementToast(res?.errorMessage, 'Error');
              this.statusToggleButton.setValue(!this.statusToggleButton.value);
            }
            this.statusToggleButton.enable();
            this.showStatusToggleSpinner = false;
          });
        } else {
          // if user cancel the popup window we need to set the toggle back
          this.statusToggleButton.setValue(!this.statusToggleButton.value)
        }
      })
  }

  public addSerial(): void {
    if (this.wgsSubscriptionForm.get('serial').value) {
      this.manageService.addWGSSerial(this.wgsSubscriptionForm.get('serial').value, this.subscriptionId, this.tenantId).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.commonService.implementToast("Updated successfully", "Success");
          this.getWGSSubscriptionDetail();
        } else {
          this.commonService.implementToast(res?.errorMessage, 'Error');
          this.showSerialSpinner = false;
        }
      });
    }
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/WGS');
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
